export { extractTagsFromSource } from './parser/extract-tags.js';
export { parseSourceRoot, type ParsedSourceRoot } from './parser/parse-source-root.js';
